import React from 'react'

const AppFooter = ({ className = '' }) => {
  const year = new Date().getFullYear()

  return (
    <footer
      className={`shrink-0 flex flex-col gap-2 border-t border-rule px-1 py-5 text-[11px] text-muted sm:flex-row sm:items-center sm:justify-between ${className}`}
    >
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span className="font-mono font-semibold uppercase tracking-[0.16em] text-paper">
          Nexus V2
        </span>
        <span className="text-rule" aria-hidden>
          /
        </span>
        <span>Outdoor Equipped</span>
        <span className="text-rule" aria-hidden>
          /
        </span>
        <span>Internal operations portal</span>
      </div>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 font-mono uppercase tracking-wide">
        <span>Internal use only</span>
        <span className="text-rule" aria-hidden>
          ·
        </span>
        <span>© {year} Outdoor Equipped</span>
      </div>
    </footer>
  )
}

export default AppFooter
